import { createSelector } from 'reselect';
import { getArmyListLoading } from '../../../myArmyList/common/selector';
import { ArmyListFormatView } from './view/ArmyListFormatView';
import { ArmyListFormated, Nullable } from '@Models';
import { formValueSelector } from 'redux-form';
import { AppState } from '@Redux/store';

const getFormatedList = (state: AppState): Nullable<ArmyListFormated> => {
  const selector = formValueSelector('format_army_list'); // <-- same as form name
  return selector(state, 'formatedArmyList') ?? null;
};

export const ArmyListFormatPresenter = createSelector(
  [getArmyListLoading, getFormatedList],
  (armyListLoading, formatedList): ArmyListFormatView => {
    return new ArmyListFormatView({
      isLoading: armyListLoading,
      canSubmit: !armyListLoading,
      canImport:
        !armyListLoading && formatedList != null && formatedList.army != null,
    });
  },
);
